import { useMemo } from 'react';

import {
    STORE_URL_ANDROID,
    STORE_URL_ANDROID_DEEPLINK,
    STORE_URL_IOS,
    STORE_URL_IOS_DEEPLINK,
} from '../helpers/constants';
import { useConferenceId } from './useConferenceId';
import { useTypedSelector } from './useTypedSelector';

type MobileOSFamily = 'Android' | 'iOS';

const isMobileOSFamily = (osFamily: string | undefined): osFamily is MobileOSFamily =>
    osFamily === 'Android' || osFamily === 'iOS';

const getFallbackMobileOSFamily = (): MobileOSFamily | undefined => {
    if (typeof navigator === 'undefined') {
        return undefined;
    }

    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes('android')) {
        return 'Android';
    }

    if (
        userAgent.includes('iphone') ||
        userAgent.includes('ipad') ||
        userAgent.includes('ipod') ||
        (userAgent.includes('macintosh') && userAgent.includes('mobile'))
    ) {
        return 'iOS';
    }

    return undefined;
};

export function useAppStoreLink() {
    const { OSFamily } = useTypedSelector((state) => state.ua);
    const confId = useConferenceId();

    return useMemo(() => {
        const mobileOSFamily = isMobileOSFamily(OSFamily) ? OSFamily : getFallbackMobileOSFamily();
        switch (mobileOSFamily) {
            case 'Android':
                return confId ? STORE_URL_ANDROID_DEEPLINK.replace('{id}', confId) : STORE_URL_ANDROID;
            case 'iOS':
                return confId ? STORE_URL_IOS_DEEPLINK.replace('{id}', confId) : STORE_URL_IOS;
            default:
                return undefined;
        }
    }, [OSFamily, confId]);
}
